const E = {
  'SAMPLE ID': 'SAMPLE I.D.',
  'COMPANY NAME': 'COMPANY NAME',
  'PROJECT REFERENCE': 'PROJECT REFERENCE',
  DATE: 'DATE',
};

const F = {
  'SAMPLE ID': 'ID DE L’ÉCHANTILLON',
  'COMPANY NAME': 'NOM DE L’ENTREPRISE',
  'PROJECT REFERENCE': 'RÉFÉRENCE DU PROJET',
  DATE: 'DATE',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/labelPreview.js